import { render, staticRenderFns } from "./Scripta.vue?vue&type=template&id=177cbe90&scoped=true&"
import script from "./Scripta.vue?vue&type=script&lang=js&"
export * from "./Scripta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177cbe90",
  null
  
)

export default component.exports